import z from "zod";

// TODO: Add actual error types for S3 external service
const s3ErrorTypeValues = [
  "PLACEHOLDER_ERROR",
  "FILE_NOT_FOUND_IN_S3",
  "DANGEROUS_CONTENT_TYPE_REJECTED",
  "SIGNED_UPLOAD_URL_TTL_EXCEEDS_MAX",
] as const;

const s3ErrorTypeSchema = z.enum(s3ErrorTypeValues);
const S3ErrorType = s3ErrorTypeSchema.enum;
type S3ErrorType = z.infer<typeof s3ErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type S3Errors =
  | {
      errorType: typeof S3ErrorType.PLACEHOLDER_ERROR;
      // TODO: Add specific data fields for S3 errors
      data: Record<string, never>;
    }
  | {
      errorType: typeof S3ErrorType.FILE_NOT_FOUND_IN_S3;
      data: undefined;
    }
  | {
      errorType: typeof S3ErrorType.DANGEROUS_CONTENT_TYPE_REJECTED;
      data: { contentType: string };
    }
  | {
      errorType: typeof S3ErrorType.SIGNED_UPLOAD_URL_TTL_EXCEEDS_MAX;
      data: { expiresIn: number; maxExpiresIn: number };
    };

export const s3ErrorDetails: Record<S3ErrorType, ErrorDetails> = {
  [S3ErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "S3 external service error",
  },
  [S3ErrorType.FILE_NOT_FOUND_IN_S3]: {
    sentryDescription: "File not found in S3",
  },
  [S3ErrorType.DANGEROUS_CONTENT_TYPE_REJECTED]: {
    sentryDescription: "Upload rejected: content type is not allowed (XSS risk)",
  },
  [S3ErrorType.SIGNED_UPLOAD_URL_TTL_EXCEEDS_MAX]: {
    sentryDescription: "Signed upload URL TTL exceeds the upload TTL ceiling the orphan sweeps trail",
  },
};
